import EviteModal from './evite_modal'
import urls from 'urls';

class AuthModal {

    settings = {
        clickOutside: true,
        width: '460px',
        title: null,
        url: urls.get('login_modal')
    };

    constructor(settings) {
        this.settings = {
            ...this.settings,
            ...settings
        };
        return new EviteModal(this.settings)
    };

}

export default AuthModal


// WEBPACK FOOTER //
// ./assets/es6/modal/auth_modal.es6